module.exports = __webpack_public_path__ + "Roboto-italic.42bbe4eefcde1297b11dc4b6491e9746.hashedasset.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/resources/fonts/Roboto/Roboto-italic.ttf
// module id = 387
// module chunks = 8